module.exports = __webpack_public_path__ + "media/images/advisor/img_6_2-657bec9876088f9e3e80bf41a8b3577e.png";